import React from "react";
import { Grid } from "components/src/components/Grid/Grid";
import { Details } from "components/src/components/Details/Details";
import { DetailProps, DetailsProps } from "components/src/components/Details/types";
import { GridCellProps } from "components/src/components/Grid/types";
import cx from "components/src/utils/cx";
import { spanMap } from "../js/MarketHeaderHelpers";

export interface MetaDataProps {
  hasDetails: boolean;
  hasCaption: boolean;
  numLabels: number;
  details?: DetailsProps;
  title?: string;
  hasSGP?: boolean;
  description?: string;
  isOddsBoost?: boolean;
}

export const MetaData = ({
  hasDetails,
  hasCaption,
  numLabels,
  details,
  title,
  hasSGP,
  description,
}: MetaDataProps) => {
  const gridCellDefaults: GridCellProps = {
    colSpan: spanMap[numLabels],
    rowSpan: hasCaption && !description && !title ? 2 : 1,
  };
  
  const sgpDetail = { leftIcon: { name: "ui_sgp", size: "lg", color: "fg-primary-strong" } } as DetailProps;
  const _details = hasSGP ? [sgpDetail] : [];
  if (Array.isArray(details) && details.length) _details.push(...details);

  if (title) {
    return (
      <Grid.Cell {...gridCellDefaults} ref={null} className="heading-sm-bold cui-text-fg-moderate">
        {title}
      </Grid.Cell>
    );
  }
  
  if (hasDetails || hasSGP) {
    return (
      <Grid.Cell {...gridCellDefaults} ref={null}>
        <div className={cx(
          { "-cui-ml-1": !!(hasSGP && !hasDetails) },
          "cui-flex cui-items-center cui-h-full"
        )}>
          <Details list={_details} />
        </div>
      </Grid.Cell>
    );
  }

  return <Grid.Cell {...gridCellDefaults} ref={null} />;
};
